//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import React from 'react';

import {
  MediaFilterParamKey,
  ModerationRejectionType,
} from '@apis/content-library/contentLibraryApiModel';
import HR from '@components/atoms/hr/HR';
import { CheckboxSetFilter } from '@components/media-filters/CheckboxSetFilter';
import { CollapsibleSection } from '@components/media-filters/CollapsibleSection';
import {
  FilterSection,
  FilterSectionTitle,
  FilterValue,
} from '@components/media-filters/filterSectionModels';
import { MediaLibraryTrackingIds } from '@media-library/constants/mediaLibraryTrackingIds';

export const DEFAULT_MODERATION_REJECTION_TYPE_FILTER_SECTION: FilterSection<string> =
  {
    options: [
      {
        isSelected: false,
        value: ModerationRejectionType.AI,
        label: 'AI Moderation',
        trackingId:
          MediaLibraryTrackingIds.MODERATION_REJECTION_TYPE_AI_CHECKBOX,
      },
      {
        isSelected: false,
        value: ModerationRejectionType.User,
        label: 'User',
        trackingId:
          MediaLibraryTrackingIds.MODERATION_REJECTION_TYPE_USER_CHECKBOX,
      },
      // TODO: PD-312521 - Add "Bazaarvoice" option once available
    ],
    paramKey: 'rejectionType',
  };

export interface ModerationRejectionTypeFilterProps {
  isDisabled?: boolean;
  isInitiallyCollapsed?: boolean;
  onChange: (
    sections: Map<MediaFilterParamKey, FilterSection<FilterValue>>,
  ) => void;
  section: FilterSection<string> | undefined;
}

export const ModerationRejectionTypeFilter = ({
  isDisabled,
  isInitiallyCollapsed,
  onChange,
  section = DEFAULT_MODERATION_REJECTION_TYPE_FILTER_SECTION,
}: ModerationRejectionTypeFilterProps) => (
  <>
    <CollapsibleSection
      isCollapsed={isInitiallyCollapsed}
      title={FilterSectionTitle[section.paramKey]}
    >
      <CheckboxSetFilter
        isDisabled={isDisabled}
        onChange={onChange}
        section={section}
      />
    </CollapsibleSection>
    <HR />
  </>
);
